import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { ImportAndExportModel } from "./importexport.model";
import { takeUntil } from "rxjs/operators";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
  selector: "importexport",
  templateUrl: "./importexport.component.html",
  styleUrls: ["./importexport.component.scss"],
})
export class ImportAndExportComponent extends BaseFormComponent<ImportAndExportModel> {
  Data: any;
  isUpload: boolean = false;
  selectedFile: any;
  SaveReportFileString: string;

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef, private sanitizer: DomSanitizer) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.apiName = "";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.InputOutputReports");
    this.setColumns();
  }

  async setColumns() {
    this.columns = [];
    this.Data = [
      { Id: 1, Title: this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.GettingReports") },
      { Id: 2, Title: this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.OutputReports") },
    ];
    this.columns.push(<form_control>{});
    this.orignalColumns = this.columns;
    this.model = new ImportAndExportModel();
    this.setValue("ImportOrExportId", this.model.ImportOrExportId, true);
    this.setValue("FilePath", this.model.FilePath);
    this.setValue("PathUpload", this.model.PathUpload);
    this.setValue("IsUpload", this.model.IsUpload);
  }
  onChanged($event) {}
  valueChange($event) {
    if ($event?.Id == 1) {
      this.isUpload = false;
      this.setValue("IsUpload", false);
    } else {
      this.isUpload = true;
      this.setValue("IsUpload", true);
    }
  }

  downloadFile(theJSON: string): void {
    const link = document.createElement("a");
    link.setAttribute("href", "data:text/json;charset=UTF-8," + encodeURIComponent(theJSON));
    link.setAttribute("download", "ExportReportInformation.json");
    link.style.display = "none";
    link.click();
  }
  async save(): Promise<void> {
    super.getDataFromFormGroup();
    if (!this.isValid()) {
      this.selectorService.submitted$.next(this.submitted);
      return;
    }
    if (!this.isUpload) this.model.SaveReportFile = JSON.parse(this.SaveReportFileString);
    await this.httpCommonService
      .create("UserLocalSetting/ImportAndExportReport", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(async (res) => {
        if (this.isUpload && res) {
          this.downloadFile(JSON.stringify(res));
        }
        this.close();
      });
  }
  isValid(): boolean {
    if (this.formGroup.controls["ImportOrExportId"].value === "1" && !this.formGroup.controls["FilePath"].value) {
      this.sts.showDialog(
        this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.RouteNotSelected"),
        this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.Attention")
      );
    }
    if (this.formGroup.controls["ImportOrExportId"].value === "2" && !this.formGroup.controls["PathUpload"].value) {
      this.sts.showDialog(
        this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.RouteNotSelected"),
        this.translate("ClientApp.Projects.FrameWorkShell.Header.ImportExport.Attention")
      );
    }
    return super.isValid();
  }

  handleUpload(event) {
    this.selectedFile = event.target.files[0];
    const fileReader = new FileReader();
    fileReader.readAsText(this.selectedFile, "UTF-8");
    fileReader.onload = () => {
      this.SaveReportFileString = fileReader.result.toString();
      console.log();
    };
    fileReader.onerror = (error) => {
      console.log(error);
    };
  }
}
